module.exports = __webpack_public_path__ + "img/img5.b2de1963.png";